/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getEntities as getEspecialties } from 'app/entities/especialty/especialty.reducer';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { createEntity, getEntity, reset, updateEntity } from './template-prescription.reducer';

export const TemplatePrescriptionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const doctors = useAppSelector(state => state.doctor.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const especialties = useAppSelector(state => state.especialty.entities);
  const templatePrescriptionEntity = useAppSelector(state => state.templatePrescription.entity);
  const loading = useAppSelector(state => state.templatePrescription.loading);
  const updating = useAppSelector(state => state.templatePrescription.updating);
  const updateSuccess = useAppSelector(state => state.templatePrescription.updateSuccess);
  const patientTypeValues = Object.keys(PatientType);

  const handleClose = () => {
    navigate(`/template-prescription${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDoctors({}));
    dispatch(getHospitals({}));
    dispatch(getEspecialties({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }

    const entity = {
      ...templatePrescriptionEntity,
      ...values,
      owner: doctors.find(it => it.id.toString() === values.owner?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
      speciality: especialties.find(it => it.id.toString() === values.speciality?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          patientType: 'OP',
          ...templatePrescriptionEntity,
          owner: templatePrescriptionEntity?.owner?.id,
          hospital: templatePrescriptionEntity?.hospital?.id,
          speciality: templatePrescriptionEntity?.speciality?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.templatePrescription.home.createOrEditLabel" data-cy="TemplatePrescriptionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.templatePrescription.home.createOrEditLabel">
              Create or edit a TemplatePrescription
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="template-prescription-id"
                  label={translate('tinyMedicRestApp.templatePrescription.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.templatePrescription.active')}
                id="template-prescription-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templatePrescription.cursor')}
                id="template-prescription-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templatePrescription.timestampEntry')}
                id="template-prescription-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templatePrescription.lastUpdated')}
                id="template-prescription-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templatePrescription.microSec')}
                id="template-prescription-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templatePrescription.patientType')}
                id="template-prescription-patientType"
                name="patientType"
                data-cy="patientType"
                type="select"
              >
                {patientTypeValues.map(patientType => (
                  <option value={patientType} key={patientType}>
                    {translate(`tinyMedicRestApp.PatientType.${patientType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.templatePrescription.templateName')}
                id="template-prescription-templateName"
                name="templateName"
                data-cy="templateName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templatePrescription.forSymptom')}
                id="template-prescription-forSymptom"
                name="forSymptom"
                data-cy="forSymptom"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templatePrescription.liver')}
                id="template-prescription-liver"
                name="liver"
                data-cy="liver"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templatePrescription.GFR')}
                id="template-prescription-GFR"
                name="GFR"
                data-cy="GFR"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templatePrescription.weightMin')}
                id="template-prescription-weightMin"
                name="weightMin"
                data-cy="weightMin"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templatePrescription.weightMax')}
                id="template-prescription-weightMax"
                name="weightMax"
                data-cy="weightMax"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templatePrescription.assessment')}
                id="template-prescription-assessment"
                name="assessment"
                data-cy="assessment"
                type="text"
                validate={{
                  maxLength: { value: 3000, message: translate('entity.validation.maxlength', { max: 3000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templatePrescription.diagnosisNotes')}
                id="template-prescription-diagnosisNotes"
                name="diagnosisNotes"
                data-cy="diagnosisNotes"
                type="text"
                validate={{
                  maxLength: { value: 3000, message: translate('entity.validation.maxlength', { max: 3000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templatePrescription.medicationPlan')}
                id="template-prescription-medicationPlan"
                name="medicationPlan"
                data-cy="medicationPlan"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                id="template-prescription-owner"
                name="owner"
                data-cy="owner"
                label={translate('tinyMedicRestApp.templatePrescription.owner')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="template-prescription-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.templatePrescription.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="template-prescription-speciality"
                name="speciality"
                data-cy="speciality"
                label={translate('tinyMedicRestApp.templatePrescription.speciality')}
                type="select"
              >
                <option value="" key="0" />
                {especialties
                  ? especialties.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/template-prescription" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TemplatePrescriptionUpdate;
